import { Button } from '@massilia/ui'
import { Link } from '@tanstack/react-router'
import { X } from 'lucide-react'

export function DepositConfirmationFailed() {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="bg-error-50 flex h-16 w-16 items-center justify-center rounded-full">
        <X className="text-error-600 h-8 w-8" />
      </div>
      <div className="flex max-w-lg flex-col items-center gap-4 text-center">
        <div className="text-gray-light-900 text-2xl font-semibold">Paiement échoué</div>
        <p className="text-gray-light-700 text-sm">
          Votre paiement n&apos;a pas pu être traité. Cela peut être dû à un refus de votre banque,
          une erreur de saisie des informations de carte, ou un problème temporaire. Veuillez
          réessayer ou contacter votre banque si le problème persiste.
        </p>

        <div className="mt-2 flex flex-wrap justify-center gap-3">
          <Link to="/payer-acompte">
            <Button type="button">Réessayer</Button>
          </Link>
          <Link to="/">
            <Button type="button" variant="outline">
              Mon espace client
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
